import React from 'react';
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
import PropTypes from 'prop-types';

const ResetPasswordForm = ({
  passwordLabel,
  passwordInputProps,
  confirmPasswordLabel,
  confirmPasswordInputProps,
  passwordErrMsg,
  confirmPasswordErrMsg,
  children,
  onSubmit,
  onCancel,
}) => {
  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit(event);
  };

  const handleCancel = (event) => {
    event.preventDefault();
    onCancel();
  };

  const isDisabled = passwordErrMsg || confirmPasswordErrMsg;

  return (
    <Form
      method="POST"
      onSubmit={(e) => {
        if (isDisabled) {
          return;
        }
        handleSubmit(e);
        e.preventDefault();
      }}
    >
      <Label className="text-center mt-3 text-danger font-weight-bold">
        Your password has expired and must be changed
      </Label>
      <FormGroup>
        <Label for={passwordLabel}>{passwordLabel}</Label>
        {passwordErrMsg && (
          <>
            <br />
            <Label
              for={passwordErrMsg}
              className="text-danger"
              style={{ fontSize: 12 }}
            >
              {passwordErrMsg}
            </Label>
          </>
        )}
        <Input {...passwordInputProps} type="password" />
      </FormGroup>
      <FormGroup>
        <Label for={confirmPasswordLabel}>{confirmPasswordLabel}</Label>
        {confirmPasswordErrMsg && (
          <>
            <br />
            <Label
              for={confirmPasswordErrMsg}
              className="text-danger"
              style={{ fontSize: 12 }}
            >
              {confirmPasswordErrMsg}
            </Label>
          </>
        )}
        <Input {...confirmPasswordInputProps} type="password" />
      </FormGroup>
      <hr />
      <Button
        size="lg"
        className="bg-gradient-theme-left border-0 h3"
        block
        type="submit"
        disabled={isDisabled}
      >
        Reset
      </Button>
      <Button size="lg" className="border-0" onClick={handleCancel} block>
        Cancel
      </Button>

      {children}
    </Form>
  );
};

ResetPasswordForm.propTypes = {
  passwordLabel: PropTypes.string,
  passwordInputProps: PropTypes.object,
  confirmPasswordLabel: PropTypes.string,
  confirmPasswordInputProps: PropTypes.object,
  passwordErrMsg: PropTypes.string,
  confirmPasswordErrMsg: PropTypes.string,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
};

ResetPasswordForm.defaultProps = {
  passwordLabel: 'Password',
  passwordInputProps: {
    type: 'password',
    placeholder: 'your password',
  },
  confirmPasswordLabel: 'Confirm Password',
  confirmPasswordInputProps: {
    type: 'password',
    placeholder: 'confirm your password',
  },
  passwordErrMsg: '',
  confirmPasswordErrMsg: '',
  onSubmit: () => {},
  onCancel: () => {},
};

export default ResetPasswordForm;
